import { RelativeMatrixPoint } from "@/types/destinyMatrix";

export const Chakra = {
  sahasrara: "#6E309B",
  ajna: "#01215E",
  vishuddha: "#00AFEE",
  anahata: "#00AF50",
  manipura: "#FEFF01",
  swadhisthana: "#FE6400",
  muladhara: "#FD0100",
};

const size1 = 28;
const size2 = 24;
const size3 = 18;
const size4 = 14;

const r1 = 25;
const r2 = 19;
const r3 = 15;
const r4 = 13;

export const relativeMatrixPoints: RelativeMatrixPoint[] = [
  {
    id: 1, // center
    matrixKey: "center",
    r: r1,
    rx: 0.5,
    ry: 0.5,
    fill: Chakra.manipura,
    border: "#FFFFFF",
    textColor: "#000000",
    textSize: size1,
  },

  // R1 CIRCLES
  {
    id: 2, // left
    matrixKey: "r1.l",
    r: r1,
    rx: 0.06,
    ry: 0.5,
    fill: Chakra.sahasrara,
    border: "#FFFFFF",
    textColor: "#FFFFFF",
    textSize: size1,
  },
  {
    id: 3, // right
    matrixKey: "r1.r",
    r: r1,
    rx: 0.937,
    ry: 0.5,
    fill: Chakra.muladhara,
    border: "#FFFFFF",
    textColor: "#FFFFFF",
    textSize: size1,
  },
  {
    id: 4, // top
    matrixKey: "r1.t",
    r: r1,
    rx: 0.5,
    ry: 0.063,
    fill: Chakra.sahasrara,
    border: "#FFFFFF",
    textColor: "#FFFFFF",
    textSize: size1,
  },
  {
    id: 5, // bottom
    matrixKey: "r1.b",
    r: r1,
    rx: 0.5,
    ry: 0.937,
    fill: Chakra.muladhara,
    border: "#FFFFFF",
    textColor: "#FFFFFF",
    textSize: size1,
  },
  {
    id: 6, // top-left
    matrixKey: "r1.tl",
    r: r1,
    rx: 0.192,
    ry: 0.192,
    fill: "#FFFFFF",
    border: "#000000",
    textColor: "#000000",
    textSize: size1,
  },
  {
    id: 7, // bottom-left
    matrixKey: "r1.bl",
    r: r1,
    rx: 0.195,
    ry: 0.807,
    fill: "#FFFFFF",
    border: "#000000",
    textColor: "#000000",
    textSize: size1,
  },
  {
    id: 8, // bottom-right
    matrixKey: "r1.br",
    r: r1,
    rx: 0.807,
    ry: 0.807,
    fill: "#FFFFFF",
    border: "#000000",
    textColor: "#000000",
    textSize: size1,
  },
  {
    id: 8, // top-right
    matrixKey: "r1.tr",
    r: r1,
    rx: 0.807,
    ry: 0.195,
    fill: "#FFFFFF",
    border: "#000000",
    textColor: "#000000",
    textSize: size1,
  },

  // R2 CIRCLES
  {
    id: 10, // left
    matrixKey: "r2.l",
    r: r2,
    rx: 0.146,
    ry: 0.5,
    fill: Chakra.ajna,
    border: "#FFFFFF",
    textColor: "#FFFFFF",
    textSize: size2,
  },
  {
    id: 11, // right
    matrixKey: "r2.r",
    r: r2,
    rx: 0.854,
    ry: 0.5,
    fill: "#FFFFFF",
    border: "#000000",
    textColor: "#000000",
    textSize: size2,
  },
  {
    id: 12, // top
    matrixKey: "r2.t",
    r: r2,
    rx: 0.5,
    ry: 0.146,
    fill: Chakra.ajna,
    border: "#FFFFFF",
    textColor: "#FFFFFF",
    textSize: size2,
  },
  {
    id: 13, // bottom
    matrixKey: "r2.b",
    r: r2,
    rx: 0.5,
    ry: 0.854,
    fill: "#FFFFFF",
    border: "#000000",
    textColor: "#000000",
    textSize: size2,
  },
  {
    id: 14, // top-left
    matrixKey: "r2.tl",
    r: r2,
    rx: 0.25,
    ry: 0.25,
    fill: "#FFFFFF",
    border: "#000000",
    textColor: "#000000",
    textSize: size2,
  },
  {
    id: 15, // bottom-left
    matrixKey: "r2.bl",
    r: r2,
    rx: 0.251,
    ry: 0.749,
    fill: "#FFFFFF",
    border: "#000000",
    textColor: "#000000",
    textSize: size2,
  },
  {
    id: 16, // bottom-right
    matrixKey: "r2.br",
    r: r2,
    rx: 0.751,
    ry: 0.747,
    fill: "#FFFFFF",
    border: "#000000",
    textColor: "#000000",
    textSize: size2,
  },
  {
    id: 17, // top-right
    matrixKey: "r2.tr",
    r: r2,
    rx: 0.748,
    ry: 0.25,
    fill: "#FFFFFF",
    border: "#000000",
    textColor: "#000000",
    textSize: size2,
  },

  // R3 CIRCLES
  {
    id: 18, // left
    matrixKey: "r3.l",
    r: r3,
    rx: 0.21,
    ry: 0.5,
    fill: Chakra.vishuddha,
    border: "#FFFFFF",
    textColor: "#FFFFFF",
    textSize: size3,
  },
  {
    id: 19, // right
    matrixKey: "r3.r",
    r: r3,
    rx: 0.79,
    ry: 0.5,
    fill: Chakra.swadhisthana,
    border: "#FFFFFF",
    textColor: "#FFFFFF",
    textSize: size3,
  },
  {
    id: 20, // top
    matrixKey: "r3.t",
    r: r3,
    rx: 0.5,
    ry: 0.21,
    fill: Chakra.vishuddha,
    border: "#FFFFFF",
    textColor: "#FFFFFF",
    textSize: size3,
  },
  {
    id: 21, // bottom
    matrixKey: "r3.b",
    r: r3,
    rx: 0.5,
    ry: 0.79,
    fill: Chakra.swadhisthana,
    border: "#FFFFFF",
    textColor: "#FFFFFF",
    textSize: size3,
  },
  {
    id: 22, // top-left
    matrixKey: "r3.tl",
    r: r3,
    rx: 0.295,
    ry: 0.295,
    fill: "#FFFFFF",
    border: "F000000",
    textColor: "#000000",
    textSize: size3,
  },
  {
    id: 23, // bottom-left
    matrixKey: "r3.bl",
    r: r3,
    rx: 0.295,
    ry: 0.705,
    fill: "#FFFFFF",
    border: "F000000",
    textColor: "#000000",
    textSize: size3,
  },
  {
    id: 24, // bottom-right
    matrixKey: "r3.br",
    r: r3,
    rx: 0.705,
    ry: 0.705,
    fill: "#FFFFFF",
    border: "F000000",
    textColor: "#000000",
    textSize: size3,
  },
  {
    id: 25, // top-right
    matrixKey: "r3.tr",
    r: r3,
    rx: 0.705,
    ry: 0.295,
    fill: "#FFFFFF",
    border: "F000000",
    textColor: "#000000",
    textSize: size3,
  },

  // MIDDLE POINTS
  {
    id: 26, // left
    matrixKey: "middle_points.l",
    r: r4,
    rx: 0.35,
    ry: 0.5,
    fill: Chakra.anahata,
    border: "#FFFFFF",
    textColor: "#FFFFFF",
    textSize: size4,
  },
  {
    id: 27, // top
    matrixKey: "middle_points.t",
    r: r4,
    rx: 0.5,
    ry: 0.35,
    fill: Chakra.anahata,
    border: "#FFFFFF",
    textColor: "#FFFFFF",
    textSize: size4,
  },
  {
    id: 28, // right
    matrixKey: "middle_points.r",
    r: r3,
    rx: 0.65,
    ry: 0.5,
    fill: "#FFFFFF",
    border: "#000000",
    textColor: "#000000",
    textSize: size4,
  },
  {
    id: 29, // right_center
    matrixKey: "middle_points.right_center",
    r: r2,
    rx: 0.585,
    ry: 0.5,
    fill: "#FFFFFF",
    border: "#000000",
    textColor: "#000000",
    textSize: size3,
  },

  // RIGHT CORNER
  {
    id: 30, // left
    matrixKey: "right_corner.l",
    r: r4,
    rx: 0.61,
    ry: 0.7,
    fill: "#FFFFFF",
    border: "#000000",
    textColor: "#000000",
    textSize: size4,
  },
  {
    id: 31, // center
    matrixKey: "right_corner.c",
    r: r4,
    rx: 0.635,
    ry: 0.635,
    fill: "#FFFFFF",
    border: "#000000",
    textColor: "#000000",
    textSize: size4,
  },
  {
    id: 32, // right
    matrixKey: "right_corner.r",
    r: r4,
    rx: 0.7,
    ry: 0.61,
    fill: "#FFFFFF",
    border: "#000000",
    textColor: "#000000",
    textSize: size4,
  },
];
